export const AppTheme = {
  // Primary Colors
  colors: {
    primary: {
      light: '#93C5FD',
      default: '#3B82F6',
      dark: '#1E40AF'
    },
    // Accent Colors
    accent: {
      teal: '#0D9488',
      violet: '#8B5CF6',
      rose: '#F43F5E',
      amber: '#F59E0B'
    },
    // Semantic Colors for general purpose indicators
    semantic: {
      success: '#047857',
      warning: '#B45309',
      danger: '#B91C1C',
      info: '#2563EB',
      neutral: '#4B5563',
    },
    // Status Colors specifically for invoice statuses
    status: {
      paid: '#047857',
      pending: '#B45309',
      overdue: '#B91C1C',
      draft: '#4B5563',
      sent: '#B45309',
      viewed: '#4B5563',
      partial: '#B45309',
      cancelled: '#B91C1C',
      refunded: '#4B5563',
      active: '#0D9488'
    },
    // Neutral Colors
    gray: {
      dark: '#1F2937',
      medium: '#6B7280',
      light: '#F3F4F6'
    },
    white: '#FFFFFF',
    // Dark mode background
    dark: {
      bg: '#111827',
      surface: '#1F2937',
      border: '#374151'
    }
  },
  // Typography
  font: {
    family: {
      primary: 'Inter, sans-serif',
      alternate: 'Roboto, sans-serif',
      mono: 'Roboto Mono, monospace'
    },
    size: {
      xs: '0.75rem',    // 12px
      sm: '0.875rem',   // 14px
      base: '1rem',     // 16px
      lg: '1.125rem',   // 18px
      xl: '1.25rem',    // 20px
      '2xl': '1.5rem'   // 24px
    },
    weight: {
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700
    },
    lineHeight: {
      headings: 1.2,
      body: 1.5,
      tables: 1.3
    }
  },
  // Border Radius
  borderRadius: {
    sm: '6px',
    md: '8px',
    lg: '12px',
    full: '9999px'
  },
  // Spacing
  spacing: {
    '1': '4px',
    '2': '8px',
    '3': '12px',
    '4': '16px',
    '5': '20px',
    '6': '24px',
    '8': '32px',
    '12': '48px'
  }
};